"use server";

import { cookies } from "next/headers";
import { revalidatePath } from "next/cache";
import {
  COOKIE_ACTIVE_TAB,
  isActiveTab,
  type ActiveTab,
} from "./types";

/**
 * Server Actions dla persistence stanu admin top bar w cookies.
 *
 * Wzorzec: zapis cookie + `revalidatePath` żeby SSR re-renderował z nowym
 * initial state (Server Component czyta cookie). Plus client-side state
 * w AdminProvider jest aktualizowany optymistycznie żeby UI reagowało
 * natychmiast bez czekania na round-trip.
 *
 * @see ../../.claude/CLAUDE.md sekcja "AdminContext"
 */

const COOKIE_OPTIONS = {
  path: "/",
  maxAge: 60 * 60 * 24 * 365, //1 year
  sameSite: "lax" as const,
  httpOnly: false, //Client component czyta dla optimistic state; pisać tylko przez Server Action
};

export async function setActiveTabAction(
  tab: ActiveTab,
): Promise<{ ok: boolean; error?: string }> {
  if (tab !== null && !isActiveTab(tab)) {
    return { ok: false, error: `Invalid active tab: ${tab}` };
  }

  const cookieStore = await cookies();
  if (tab === null) {
    //Clear cookie zamiast set'ować pusty string
    cookieStore.delete(COOKIE_ACTIVE_TAB);
  } else {
    cookieStore.set(COOKIE_ACTIVE_TAB, tab, COOKIE_OPTIONS);
  }

  revalidatePath("/", "layout");
  return { ok: true };
}
